module.exports = __webpack_public_path__ + "static/card-funded-projects-2-75dbf384173bc651354537e713a99d76.png";